export enum KnockWorkflowKeys {
    PROPOSAL_CREATED = 'proposal-created',
    PROPOSAL_STATUS = 'proposal-status-changed',
    NEWS_CREATED = 'news-created',
    FLASHNOTE_CREATED = 'flashnote-created',
    REPORT_CREATED = 'report-created',
    DASHBOARD_CREATED = 'dashboard-created',
}
